/**
 * Hardcoded MVP targets shown beneath each metric card. These will move to a
 * server-driven source once product/backend defines a target API.
 */
export const CUSTOMER_LOVE_ERP_TARGET = 4.8;

export const TRANSFER_RATE_TARGET_PERCENT = 6;

export const TRANSFER_RATE_CEILING_PERCENT = TRANSFER_RATE_TARGET_PERCENT * 2;

export const SALES_TARGET = 1;

export interface RingGradient {
    highlight: string;
    main: string;
    deep: string;
}

export const CUSTOMER_LOVE_GRADIENT: RingGradient = {
    highlight: "var(--mantine-color-pink-2)",
    main: "var(--mantine-color-pink-5)",
    deep: "var(--mantine-color-red-7)",
};

export const QUALITY_EFFICIENCY_GRADIENT: RingGradient = {
    highlight: "var(--mantine-color-pink-2)",
    main: "var(--mantine-color-pink-5)",
    deep: "var(--mantine-color-violet-7)",
};

export const SALES_OPPORTUNITIES_GRADIENT: RingGradient = {
    highlight: "var(--mantine-color-teal-2)",
    main: "var(--mantine-color-teal-5)",
    deep: "var(--mantine-color-teal-8)",
};
